// extracted by mini-css-extract-plugin
export var dateLabel = "_3t-0";
export var dateLabelError = "_3t-1";
export var fullWidth = "_3t-2";
export var smaller = "_3t-3";